// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3lu7Q","bigColWidth":"Table_bigColWidth__5Qyt1","biggerColWidth":"Table_biggerColWidth__1vSDl","row":"Table_row__ru99c","col":"Table_col__2oXeW"};